import React from 'react';
import client from '../../../../lib/client';
import { logger } from '../../../../lib/helpers';
import {
  InactivateAccountMembershipMutation,
  InactivateAccountMembershipMutationVariables
} from '../../../../queries/__generated__/InactivateAccountMembershipMutation';
import {
  inactivateAccountMembershipMutation,
  accountMembersQuery
} from '../../../../queries/account';
import { Icon } from '../../../ui';

interface RemoveMemberButtonProps {
  member: {
    id: string;
  };
  account: {
    id: string;
  };
}

const RemoveMemberButton: React.FC<RemoveMemberButtonProps> = ({ member, account }) => {
  async function removeMemberFromGroup() {
    console.log(member, account);
    await client
      .mutate<InactivateAccountMembershipMutation, InactivateAccountMembershipMutationVariables>({
        mutation: inactivateAccountMembershipMutation,
        variables: { id: member.id },
        refetchQueries: [
          {
            query: accountMembersQuery,
            variables: { input: { accountId: account.id } }
          }
        ]
      })
      .then(res => logger(res));
  }

  return (
    <button
      onClick={removeMemberFromGroup}
      className="flex items-center pointer blue hover-navy"
      data-testid="remove-member-button"
    >
      <Icon name="close" size={18} color="blue" />
    </button>
  );
};

export default RemoveMemberButton;
